import { render, staticRenderFns } from "./ripple.vue?vue&type=template&id=25c51b1e&scoped=true"
import script from "./ripple.vue?vue&type=script&lang=js"
export * from "./ripple.vue?vue&type=script&lang=js"
import style0 from "./ripple.vue?vue&type=style&index=0&id=25c51b1e&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c51b1e",
  null
  
)

export default component.exports